import { Box, Button } from '@chakra-ui/react';
import PreviewTemplate from '../actions/PreviewTemplate';
import EmptySections from '../actions/EmptySections';
import React from 'react';
import RSAccordionAction from '../actions/RSAccordionAction';
import Index from './Notes';
import CoverLetter from '../actions/CoverLetter';


const Actions = ({ myData, props, previews, styles }) => {

  const style = {...styles.sidebar, ...styles.accordion, ...styles.section};
  return (
    <Box sx={{...style}} >
      <PreviewTemplate myData={myData} props={props} previews={previews} styles={styles} />
      <RSAccordionAction label='Empty Sections'>
        <EmptySections props={props}  />
      </RSAccordionAction>
      <RSAccordionAction label='Cover Letter'>
      <CoverLetter props={props} />
      </RSAccordionAction>
    </Box>
  );
};
export default Actions;
/*
      <RSAccordionAction  label='Notes'>
        <Notes styles={styles} myData={myData}/>
      </RSAccordionAction>
 */